import { useQuery } from "@tanstack/react-query";
import { useEvent } from "../context/EventProvider";
import { fetchForms, type Form } from "./forms";
import { fetchTranslations, type Translations } from "./formI18n";

/**
 * LES DEUX LECTURES QUE TOUT CE QUI TOUCHE À UN FORMULAIRE PARTAGE.
 *
 * ⚠️ ELLES ÉTAIENT ÉCRITES SIX FOIS, à l'identique — la clé, le `staleTime`, le `retry`,
 * la garde `enabled`. Le cache les réunissait par la clé, donc rien ne coûtait plus
 * cher ; ce qui coûtait, c'est qu'aucune n'était la référence. Chacune pouvait dériver
 * sans qu'un test ni un type ne s'y oppose, et la première divergence n'aurait touché
 * qu'un écran sur six — celui qu'on ne regarde pas.
 *
 * ⚠️ SANS DÉPENDANCE SUR LES RÉGLAGES, ET C'EST CE QUI LES MET ICI plutôt que dans
 * `useForm.ts` : le fournisseur des réglages en a besoin lui aussi (il publie `forms`
 * pour le panneau), et il ne peut pas importer ce qui l'importe.
 */

/** Les formulaires de l'événement, avec leurs champs. Une lecture pour toute la visite. */
export function useForms(): ReadonlyArray<Form> {
  const event = useEvent();
  const { data } = useQuery({
    queryKey: ["forms", event?.domainId, event?.eventId],
    queryFn: ({ signal }) => fetchForms(event!.domainId, event!.eventId, signal),
    enabled: !!event,
    /* Un formulaire ne change pas pendant qu'on s'inscrit. Quand il change — l'éditeur
       du panneau l'a réécrit — c'est cette écriture-là qui invalide la clé. */
    staleTime: Infinity,
    retry: false,
  });
  return data ?? [];
}

/**
 * Les traductions du produit pour cet événement — le magasin partagé avec la V1 et le
 * back office. Voir `fetchTraductions`, qui explique pourquoi c'est une requête à part
 * de celle du catalogue des langues.
 */
export function useTranslations(): Translations | undefined {
  const event = useEvent();
  const { data } = useQuery({
    queryKey: ["form-i18n", event?.domainId, event?.eventId],
    queryFn: ({ signal }) => fetchTranslations(event!, signal),
    enabled: !!event,
    staleTime: Infinity,
    retry: false,
  });
  return data;
}
